export default function Card({ children, className = '', ...props }) {
    return (
        <div className={`bg-white rounded-xl shadow-sm border border-gray-200 ${className}`} {...props}>
            {children}
        </div>
    );
}

export function CardHeader({ children, className = '' }) {
    return <div className={`px-6 py-4 border-b border-gray-100 ${className}`}>{children}</div>;
}

export function CardBody({ children, className = '' }) {
    return <div className={`px-6 py-4 ${className}`}>{children}</div>;
}
